import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AccountServiceProxy } from '@shared/service-proxies/service-proxies';
import { LoadingController, AlertController, ModalController } from '@ionic/angular';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-help-desk',
  templateUrl: './help-desk.page.html',
  styleUrls: ['./help-desk.page.scss'],
})
export class HelpDeskPage implements OnInit {

  formGroup : FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private acctService: AccountServiceProxy,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private modalController: ModalController,
    private titleService: Title
  ) { 
    this.titleService.setTitle('OACI - Help Desk');
    this.setupForm();
  }

  ngOnInit() {
  }

  setupForm() {
    this.formGroup = this.formBuilder.group({
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
  }

  async submitForm() {
    
    const loading = await this.loadingController.create({
      message: 'Sending message...',
    });
    await loading.present();
    
    const request = this.formGroup.getRawValue();
    this.acctService.sendHelpDeskEmail(request).subscribe(
      async dto => {
        await loading.dismiss();
        this.modalController.dismiss({
          'didSend': true
        });
      },
      async error => {
        this.sendError(error).then();
        await loading.dismiss();
      }
    );
  }

  async sendError(errorMessage) {
    const alert = await this.alertController.create({
      header: 'Error',
      subHeader: 'Error',
      message: errorMessage,
      buttons: ['OK']
    });

    await alert.present();
  }

  cancel() {
    this.modalController.dismiss();
  }

}
